import { Navigate, createFileRoute, useRouterState } from '@tanstack/react-router';
import { legacyFeedTarget } from '../lib/feed-search.js';

/** Notifications became the Feed; bookmarks and sent alert emails still use this path. */
export const Route = createFileRoute('/notifications')({
  component: LegacyNotificationsRedirect,
});

export function LegacyNotificationsRedirect() {
  const search = useRouterState({ select: (state) => state.location.searchStr });
  const target: string = legacyFeedTarget(search, null);
  return <Navigate to={target} replace />;
}
